import useOnAnnotationPopupOpen from './useOnAnnotationPopupOpen';

export default useOnAnnotationPopupOpen;